import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Z_INDEX } from "../styles/zIndex";

interface Props {
	message: string;
}

const dotPatterns = [".", "..", "..."];

const LoadingModal = ({ message }: Props) => {
	const { t } = useTranslation();
	const [dotIndex, setDotIndex] = useState(0);
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		intervalRef.current = setInterval(() => {
			setDotIndex((prev) => (prev + 1) % dotPatterns.length);
		}, 500);
		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
		};
	}, []);

	let formattedMessage = message;
	if (message === "DEFAULT") {
		formattedMessage = t("common:loadingModal.default");
	} else if (message === "FETCH") {
		formattedMessage = t("common:loadingModal.fetch");
	} else if (message === "SAVE") {
		formattedMessage = t("common:loadingModal.save");
	} else if (message === "DELETE") {
		formattedMessage = t("common:loadingModal.delete");
	} else if (message === "UPDATE") {
		formattedMessage = t("common:loadingModal.update");
	} else if (message === "PROCESS") {
		formattedMessage = t("common:loadingModal.process");
	} else if (message === "LOAD") {
		formattedMessage = t("common:loadingModal.load");
	} else if (message === "CONNECT") {
		formattedMessage = t("common:loadingModal.connect");
	} else if (message === "AUTHENTICATE") {
		formattedMessage = t("common:loadingModal.authenticate");
	} else if (message === "VALIDATE") {
		formattedMessage = t("common:loadingModal.validate");
	} else if (message === "EXPORT") {
		formattedMessage = t("common:loadingModal.export");
	} else if (message === "PRINT") {
		formattedMessage = t("common:loadingModal.print");
	} else {
		formattedMessage = message;
	}
	formattedMessage = formattedMessage.replace(/\.*$/, ""); // Remove trailing dots
	const animatedMessage = `${formattedMessage}${dotPatterns[dotIndex]}`;

	return (
		<Dialog
			open={true}
			sx={{ zIndex: Z_INDEX.loadingOverlay }}
			PaperProps={{ sx: { p: 2, textAlign: 'center' } }}
		>
			<DialogContent sx={{ textAlign: 'center' }}>
				<CircularProgress color="primary" />
				<p>{animatedMessage}</p>
			</DialogContent>
		</Dialog>
	);
};

export default LoadingModal;